import { Capacity, Direction, DirectionOption, DirectionType, PointType, ChildrenAge } from './Transfer.types';

export const DIRECTION_TITLES = {
  [Direction.There]: 'Трансфер туда',
  [Direction.Back]: 'Трансфер обратно',
};

export const POINT_ICONS = {
  [PointType.Airport]: 'plane',
  [PointType.Hotel]: 'hotel',
};

export const TYPE_TITLES = {
  [DirectionType.Public]: 'Без трансфера',
  [DirectionType.Group]: 'Групповой',
  [DirectionType.Individual]: 'Индивидуальный',
};

export const TYPE_OPTION_TITLES = {
  [DirectionOption.Economy]: 'Economy',
  [DirectionOption.Comfort]: 'Comfort',
  [DirectionOption.Business]: 'Business',
  [DirectionOption.Premium]: 'Premium',
  [DirectionOption.Limousine]: 'Limousine',
  [DirectionOption.SUV]: 'SUV',
  [DirectionOption.Van]: 'Van',
  [DirectionOption.Minibus]: 'Minibus',
  [DirectionOption.Bus]: 'Bus',
  [DirectionOption.Helicopter]: 'Helicopter',
  [DirectionOption.Boat]: 'Boat',
};

export const SEATS_TYPES = {
  [ChildrenAge.Infant]: 'Детское кресло 0-1',
  [ChildrenAge.Child]: 'Детское кресло 1-8',
  [ChildrenAge.Teenager]: 'Детское кресло 8-14',
};

export const CAPACITY_ICONS = {
  [Capacity.Adult]: 'user',
  [Capacity.Children]: 'child',
  [Capacity.Luggage]: 'luggage',
};

export const OPTION_TITLES = {
  [DirectionOption.Economy]: 'Эконом',
  [DirectionOption.Comfort]: 'Комфорт',
  [DirectionOption.Business]: 'Бизнес',
  [DirectionOption.Premium]: 'Премиум',
  [DirectionOption.Limousine]: 'VIP',
  [DirectionOption.SUV]: 'Внедорожник',
  [DirectionOption.Van]: 'Минивэн',
  [DirectionOption.Minibus]: 'Микроавтобус',
  [DirectionOption.Bus]: 'Автобус',
  [DirectionOption.Helicopter]: 'Вертолет',
  [DirectionOption.Boat]: 'Катер',
};

export const FOR_FREE_TEXT = 'Бесплатно';
